import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoBuscaSefazRequest } from '../../requests/dfe/configuracao-busca-sefaz.request';
import { ConfiguracaoBuscaSefazResponse } from '../../responses/dfe/configuracao-busca-sefaz.response';
import { StatusBuscaSefazResponse } from '../../responses/dfe/status-busca-sefaz.response';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoBuscaSefazService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}configuracao-busca-sefaz`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<ConfiguracaoBuscaSefazResponse> {
    return this.httpClient
      .get<ConfiguracaoBuscaSefazResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getStatus(): Observable<StatusBuscaSefazResponse> {
    return this.httpClient
      .get<StatusBuscaSefazResponse>(`${this.apiUrl}/status`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public put(request: ConfiguracaoBuscaSefazRequest): Observable<ConfiguracaoBuscaSefazResponse> {
    return this.httpClient
      .put<ConfiguracaoBuscaSefazResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
